const constants = {
  MOBILE_WIDTH: 768,
  MIN_DESKTOP_WIDTH: 992,
};

const events = {
  BASKET_NOTIFICATION: "basket-notification",
  BASKET_UPDATE: "basket_update",
  THIRD_PARTY_PAYMENT_COMPLETE: "third_party_payment_complete",
  INIT_THIRD_PARTY_PAYMENTS: "init_third_party_payments",
  NAV_OPENING: "nav_opening",
  ORDER_UPDATE_END: "order_update_end",
  ORDER_UPDATE_START: "order_update_start",
  R4R_REFRESH: "rewards_refresh",
  R4R_REGISTERED_CHECK: "rewards_registered",
  REPORT_ERROR: "report_error",
  SET_BASKET_EXPIRY_TIMER: "set_basket_expiry_timer",
  SHOW_TICKET_BASKET_FAIL: "show_ticket_basket_fail",
  START_LOADING: "start_loading",
  STOP_LOADING: "stop_loading",
  UPDATE_BASKET_BAR: "update_basket_bar",
};

const classes = {
  HIDDEN: "u-hidden",
  LOADING: "is-loading",
};

const attributes = {
  price: "data-price",
  quantity: "data-quantity",
  itemTracking: "data-item-tracking",
  orderTracking: "data-order-tracking",
  trackingBeginCheckout: "data-track-begin-checkout",
  itemUpgradeTracking: "data-item-upgrade-tracking",
};

const ecommerceEvents = {
  view_item_list: "view_item_list",
  add_to_cart: "add_to_cart",
  remove_from_cart: "remove_from_cart",
  view_cart: "view_cart",
  begin_checkout: "begin_checkout",
  add_shipping_info: "add_shipping_info",
  add_payment_info: "add_payment_info",
};

export { constants, events, classes, ecommerceEvents, attributes };
